
import { eTraCuuDiemActionsObj } from "../../action-types/tra-cuu-diem/ITraCuuDiemActionsType";
import { generateActions } from "../generateActions";

export const traCuuDiemActions = {
    ...generateActions(eTraCuuDiemActionsObj, "TRA_CUU_DIEM"),
}